import React, { useContext } from 'react';
import AppContext from 'app/AppContext';
import { usePointedTime } from 'utils/components/TimeSeriesChart/timepoint';
import {
    FillsGraphData,
    formatRelPerfIndexLegendData,
} from 'widgets/fillsGraph/fillsGraphData';
import FillsChartToggleLegend from '../legend/FillsChartToggleLegend';
import { getPerfVsIndexLabel } from '../legend/labels';
import { FillsChartType } from '../store/configuration/FillsGraphConfiguration';
import PerformanceVsIndexHelp from './help/PerformanceVsIndexHelp';
import {
    performanceVsTooltip,
    indexTooltip,
} from './help/performanceVsIndexLegendTooltips';
import { CollapseCompanionChartToggleButton } from 'widgets/fillsGraph/collapsableCompanionCharts/CollapseCompanionChartToggleButton';
import { FillsGraphPortfolioData } from 'widgets/fillsGraph/fillsGraphPortfolioData';
import { useLegendStatus } from 'widgets/fillsGraph/legendStatus';

interface PerformanceVsIndexChartLegendProps {
    fillsGraphData: FillsGraphData;
    fillsGraphPortfolioData: FillsGraphPortfolioData;
    relativePerformanceIndex: string;
    fillsGraphContainerLeft: number;
}

export default function PerformanceVsIndexChartLegend(
    props: PerformanceVsIndexChartLegendProps
) {
    const {
        fillsGraphData,
        fillsGraphPortfolioData,
        relativePerformanceIndex,
        fillsGraphContainerLeft,
    } = props;
    const time = usePointedTime('PerformanceVsIndexChartLegend');
    const { numberFormat } = useContext(AppContext);

    const legendData = formatRelPerfIndexLegendData(
        fillsGraphData,
        numberFormat,
        time
    );

    const { allPerformanceVsIndexChartHidden: allHidden } = useLegendStatus(
        fillsGraphData,
        fillsGraphPortfolioData
    );

    if (allHidden) {
        return <></>;
    }

    return (
        <div className="PerformanceVsIndexChartLegend">
            <FillsChartToggleLegend
                className="order-to-index"
                label={getPerfVsIndexLabel(relativePerformanceIndex)}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                twoColourBorder={true}
                value={legendData.relativePerfOrderToIndex}
                suffix={legendData.relativePerfOrderToIndex ? '%' : ''}
                chart={FillsChartType.PerformanceVsIndex}
                property="displayPerformanceVsIndex"
                hideLegendProperty="hidePerformanceVsIndexLegend"
                tooltip={performanceVsTooltip}
            />
            <FillsChartToggleLegend
                className="index"
                label={`${relativePerformanceIndex}`}
                fillsGraphContainerLeft={fillsGraphContainerLeft}
                value={legendData.relativePerfIndex}
                suffix={legendData.relativePerfIndex ? '%' : ''}
                chart={FillsChartType.PerformanceVsIndex}
                property="displayIndex"
                hideLegendProperty="hideIndexLegend"
                tooltip={indexTooltip}
            />
            <PerformanceVsIndexHelp />
            <CollapseCompanionChartToggleButton
                section={FillsChartType.PerformanceVsIndex}
            />
        </div>
    );
}
